import { useEffect } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { SuperAdminRouter } from './SuperAdminRouter';
import { HomeRouter } from './HomeRouter';
import { PrivateRoute2 } from './PrivateRoute2';
import { PublicRoute2 } from './PublicRoute2';
import { AuthAdminRoute } from './AuthAdminRoute';
import { CargandoInformacion } from '../components/components';
import { useAuthStore } from '../stores/usuarios/auth.store';



// import { startChekingSuper } from '../actions/admin';
// import { OlvideMiPassword } from '../components/auth/OlvideMiPassword';
// import { NuevoPassword } from '../components/auth/NuevoPassword';
// import { LoginClientes, RegisterCliente } from '../components/auth/pages';
// import { TerminosYCondiciones } from '../components/home/pages';



export const AppRouter = () => {


    const authStatus = useAuthStore(state => state.status);
    const checkStatus = useAuthStore(state => state.startCheckStatus);
    const checkStatusCliente = useAuthStore(state => state.startCheckStatusCliente);



    useEffect(() => {
        checkStatus();
        checkStatusCliente();
    }, []);



    if(authStatus === 'pending'){
        return( <CargandoInformacion titulo="Cargando..." /> )
    } 



    return (

        <BrowserRouter future={{ v7_startTransition:true, v7_relativeSplatPath:true }} >

            <Routes>
                <Route path="/admin/*"
                    element={
                        <PublicRoute2>
                            <AuthAdminRoute />
                        </PublicRoute2>
                    }
                />

                <Route path="/super/*" 
                    element={
                        <PrivateRoute2>
                            <SuperAdminRouter />
                        </PrivateRoute2>
                    } 
                />
                
                <Route path="/*" element={<HomeRouter />} />


                {/* <Route path="/login" element={<LoginClientes />} />
                <Route path="/register" element={<RegisterCliente />} />
                <Route path="/olvide-password" element={<OlvideMiPassword />} />
                <Route path="/nuevo-password/:token" element={<NuevoPassword />} />
                <Route path="/terminos" element={ <TerminosYCondiciones /> }/>  */}



                {/* <Route path="/*" element={ <Navigate to="/home" replace /> }/> */}
            </Routes>
        </BrowserRouter>
    )
}
